'use strict'

import {VIEWS} from '@/views/names'

export default {
  install(Vue, store, router) {
    Vue.prototype.$pageManager = {
      showInit() {
        toPage(VIEWS.init)
      },
      showLoad() {
        toPage(VIEWS.load)
      },
      showError(params) {
        toPage(VIEWS.error, params)
      },
      showReceipt() {
        toPage(VIEWS.receipt)
      }
    }

    function toPage(view, params = {}) {
      // https://github.com/vuejs/vue-router/issues/2881
      router.push({
        name: view.name,
        params: params
      })
        .catch((e) => {
          // do nothing
        })
    }
  }
}
